var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSweet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2725 6.72078L30.5632 9.45906C32.1535 8.80233 33.1714 7.82948 32.9757 7.02403C32.8502 6.5096 32.2533 6.16128 31.3918 6.01513C32.2688 4.53171 32.4362 3.06632 31.6848 2.31495C30.9341 1.56423 29.4687 1.73098 27.9846 2.6079C27.8391 1.74644 27.4908 1.14895 26.9764 1.02404C26.1728 0.828957 25.2038 1.83851 24.5471 3.42043L27.2725 6.72078Z",
    fill: "#FBCD33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9819 5.32506L25.542 8.28611L28.6588 10.0206C29.331 9.89315 29.9774 9.70064 30.5633 9.45855C29.1404 6.89347 27.0376 4.81192 24.5466 3.41992C24.3077 3.99488 24.1146 4.63164 23.9819 5.32506Z",
    fill: "#F2B537"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48384 27.1187L3.42042 24.5459C1.83914 25.202 0.828945 26.1723 1.02403 26.9751C1.14894 27.4896 1.74642 27.8379 2.60789 27.9834C1.73097 29.4674 1.56357 30.9322 2.31494 31.6836C3.06566 32.4349 4.53105 32.2682 6.01447 31.3913C6.16063 32.2527 6.50895 32.8496 7.02338 32.9751C7.82947 33.1708 8.80232 32.1536 9.45904 30.5626L6.48384 27.1187Z",
    fill: "#FBCD33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0211 28.6583L8.09344 25.5737L5.32555 23.9814C4.63084 24.1141 3.99408 24.3079 3.42041 24.5461C4.83043 27.0687 6.91842 29.1515 9.45968 30.5628C9.70176 29.9763 9.89427 29.3299 10.0211 28.6583Z",
    fill: "#F2B537"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57098 21.3545L7.36646 23.2236V26.5902C9.42096 28.6448 12.1425 30.0567 15.2008 30.4565L12.1728 25.0592L9.57098 21.3545Z",
    fill: "#B6E9F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9784 16.9785L12.1721 17.5902L9.57031 21.3547C10.4788 24.9487 12.4798 28.1074 15.2001 30.4568C15.7821 30.5327 16.3751 30.5727 16.9778 30.5727L16.9784 16.9785Z",
    fill: "#D7F5F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9786 30.572C11.9083 23.2142 16.9786 16.9785 16.9786 16.9785L26.5905 26.5905C24.131 29.0513 20.7328 30.572 16.9786 30.572Z",
    fill: "#F7616C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 16.9785H30.5718C30.5718 20.7321 29.0504 24.131 26.5902 26.5905C17.8024 24.9738 16.9783 16.9785 16.9783 16.9785Z",
    fill: "#D7F5F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5728 16.9792C23.2149 22.0494 16.9792 16.9792 16.9792 16.9792L26.5906 7.36719C29.1247 9.90136 30.5728 13.3279 30.5728 16.9792Z",
    fill: "#F7616C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 16.9789V3.38477C20.645 3.38477 24.0683 4.84436 26.5902 7.3663C24.9735 16.1548 16.9783 16.9789 16.9783 16.9789Z",
    fill: "#D7F5F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2008 3.5C12.1579 3.89725 9.43126 5.30019 7.36646 7.36629L9.02822 8.99457L11.1053 8.62823L13.7592 6.86988L15.2008 3.5Z",
    fill: "#DC4A55"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9784 16.9783C16.9784 16.9783 22.0487 10.7426 16.9784 3.38477C16.3757 3.38477 15.7828 3.42468 15.2007 3.50066C13.5383 4.93579 12.1457 6.67417 11.1052 8.62888L14.2742 12.8042L16.9784 16.9783Z",
    fill: "#F7616C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36655 7.36719C4.90577 9.82732 3.38501 13.2255 3.38501 16.9791L9.16417 14.774L10.7654 12.3113L11.1054 8.62912C10.0553 8.07735 8.821 7.63438 7.36655 7.36719Z",
    fill: "#B6E9F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9787 16.9789C16.9787 16.9789 16.4037 11.411 11.1055 8.62891C10.1082 10.5031 9.43601 12.5757 9.16431 14.7738L16.9787 16.9789Z",
    fill: "#D7F5F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16416 14.7734C7.39874 14.9408 5.43565 15.566 3.38501 16.9786C3.38501 20.6453 4.8446 24.0686 7.36654 26.5906C7.71422 24.7028 8.40635 22.9097 9.57107 21.3548L10.4757 18.0403L9.16416 14.7734Z",
    fill: "#DC4A55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9786 16.9787C16.9786 16.9787 13.7343 14.3409 9.16424 14.7735C8.89189 16.9755 9.02839 19.2096 9.57115 21.3549C12.5026 17.4403 16.9786 16.9787 16.9786 16.9787Z",
    fill: "#F7616C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.547 3.42171L24.5464 3.42106C25.2031 1.83914 26.1727 0.828944 26.9756 1.02403C27.4907 1.14958 27.839 1.74642 27.9845 2.60853C29.4686 1.73097 30.9333 1.56422 31.6847 2.31494C32.4361 3.06631 32.2693 4.5317 31.3918 6.01512C32.2532 6.16127 32.8501 6.50959 32.9756 7.02402C33.172 7.83012 32.1541 8.80297 30.5638 9.45969",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6587 10.0214C29.3315 9.89456 29.9779 9.70205 30.5638 9.45996",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9824 5.32572C24.1144 4.6323 24.3082 3.99683 24.5471 3.42188",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42043 24.5459C1.83851 25.202 0.828957 26.1722 1.02404 26.9751C1.14895 27.4896 1.74644 27.8379 2.6079 27.9834C1.73098 29.4681 1.56423 30.9322 2.31559 31.6836C3.06632 32.4356 4.53107 32.2682 6.01513 31.3912C6.16128 32.2527 6.5096 32.8496 7.02403 32.9751C7.83013 33.1708 8.80298 32.1529 9.4597 30.5626",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0199 28.6572L10.0205 28.6579C10.0205 28.6579 10.0211 28.6579 10.0211 28.6585C9.89431 29.33 9.7018 29.9765 9.45972 30.563",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42041 24.5461C3.99408 24.3079 4.63084 24.1141 5.32554 23.9814",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2008 30.4565C13.3214 30.2112 11.5695 29.5834 10.021 28.6588C10.021 28.6582 10.0204 28.6582 10.0204 28.6582L10.0197 28.6576C9.04882 28.0787 8.15838 27.3821 7.36646 26.5908",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9786 30.5729C16.3759 30.5729 15.783 30.533 15.2009 30.457",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9786 16.9795C16.9786 16.9795 16.9715 16.9801 16.958 16.9821L16.9278 16.9859C16.9162 16.9872 16.902 16.9892 16.8866 16.9911C16.8853 16.9911 16.8846 16.9917 16.8833 16.9917C16.873 16.993 16.8621 16.9949 16.8499 16.9962",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5905 26.5915C24.131 29.0516 20.7322 30.573 16.9786 30.573C11.9083 23.2151 16.9786 16.9795 16.9786 16.9795C16.9786 16.9795 16.9792 16.9801 16.9805 16.9814",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9785 16.9795C16.9785 16.9795 17.8026 24.9741 26.5905 26.5915C29.0512 24.1313 30.572 20.7331 30.572 16.9795",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5905 7.36621C27.3927 8.16844 28.0861 9.06017 28.6585 10.0208C29.896 12.0927 30.572 14.4833 30.572 16.9788C23.2908 21.9963 17.1086 17.0831 16.9804 16.9808C16.9792 16.9795 16.9785 16.9788 16.9785 16.9788C16.9785 16.9788 16.9792 16.9782 16.9804 16.9769",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5905 7.3663C26.5049 7.83245 26.4012 8.27541 26.2814 8.69778C24.1484 16.2398 16.9785 16.9789 16.9785 16.9789C16.9785 16.9789 16.9792 16.9783 16.9804 16.977C17.0828 16.8489 21.996 10.6667 16.9785 3.38477C19.4992 3.38477 21.9052 4.07497 23.9823 5.32532C24.9262 5.89383 25.8024 6.57824 26.5905 7.3663Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1059 8.62793L11.1052 8.62857",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36646 7.36662C9.43126 5.30117 12.1579 3.89823 15.2008 3.50098",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1059 8.62793L11.1052 8.62857V8.62922",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2007 3.50066C15.7827 3.42468 16.3757 3.38477 16.9783 3.38477C21.9958 10.6667 17.0826 16.8489 16.9803 16.977C16.979 16.9783 16.9783 16.9789 16.9783 16.9789",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1051 8.62879V8.62815C10.055 8.07702 8.82011 7.63405 7.36631 7.36621C4.90553 9.82634 3.38477 13.2246 3.38477 16.9788",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.105 8.62857V8.62793C16.4032 11.4106 16.9781 16.9786 16.9781 16.9786",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57082 21.3548C8.40611 22.9097 7.71398 24.7028 7.3663 26.5912C6.57823 25.8032 5.89383 24.9269 5.32531 23.9824C4.07497 21.9053 3.38477 19.4999 3.38477 16.9793C5.43541 15.566 7.39849 14.9408 9.16391 14.7734",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16382 14.7735C13.7338 14.3409 16.9782 16.9793 16.9782 16.9793C16.9782 16.9793 16.9711 16.98 16.9576 16.9819C16.9498 16.9826 16.9395 16.9838 16.9273 16.9858C16.9157 16.9871 16.9016 16.989 16.8861 16.9909C16.8848 16.9909 16.8842 16.9916 16.8829 16.9916C16.2204 17.0843 12.2498 17.7771 9.57073 21.3549",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweet);
export default __webpack_public_path__ + "static/media/sweet.34af9d7e1d44dbb7e95f075a6507efbb.svg";
export { ForwardRef as ReactComponent };